import React from 'react'
import EditCompany from '../../components/EditCompany'
import { useParams } from 'react-router-dom'
import { getCompanyWithId, updateCompany } from '../../api/financialApi'

const EditFinancialCompany = () => {
  const { id } = useParams()
  return (
    <>
      <EditCompany
        id={id}
        companyFrom="financial"
        apiConfig={{
          updateFn: updateCompany,

          getFn: getCompanyWithId,
        }}
      />
    </>
  )
}

export default EditFinancialCompany
